module.exports = __webpack_public_path__ + "static/media/world-can-can.e2478a08.mp4";